import { useQuery } from '@tanstack/react-query';
import { TodoService } from '@/services/todoService';

// The root every todos list is keyed under. useSendToClientMutation invalidates THIS, not a
// per-company key, so a send refreshes whichever lists are mounted (FIN-875).
export const todosQueryRoot = ['todos'] as const;

const todosQueryKey = (companyId: string | undefined) =>
  [...todosQueryRoot, companyId] as const;

export function useTodos(companyId: string | undefined) {
  return useQuery({
    queryKey: todosQueryKey(companyId),
    queryFn: () => TodoService.listTodos(companyId as string),
    enabled: !!companyId,
  });
}

const todosAllQueryKey = [...todosQueryRoot, 'all'] as const;

/**
 * platform-admin-cross-client-todos.AC1 — every company's actionable todos, for the
 * platform-admin cross-company list. Keyed under the same root as the per-company list so one
 * invalidation after a send refreshes whichever of the two is mounted.
 *
 * `enabled` is the caller's `isPlatformAdminView`, not merely "no company selected": a
 * consultant between company switches also has no active company, and must not fall into this
 * list (EC5). The server refuses them regardless; this keeps the request from being made.
 */
export function useAllTodos(enabled: boolean) {
  return useQuery({
    queryKey: todosAllQueryKey,
    queryFn: () => TodoService.listAllTodos(),
    enabled,
  });
}
